import React, {
  useRef,
  useMemo,
} from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, Stack, Typography } from "@mui/material";
import { CollapseAdd } from "../App/CollapseButtons.jsx";
import QuickStartIcon from "./QuickIcon.jsx";
import { CrumbToggleScenario } from "./CrumbToggles.jsx";
import { useCallback } from "react";
import {
  ClientSideRowModelModule,
  ColumnAutoSizeModule,
  RenderApiModule,
  ValidationModule,
  CellStyleModule,
  RowSelectionModule,
  TooltipModule,
  PinnedRowModule,
  TextFilterModule,
  TextEditorModule,
  RowAutoHeightModule,
  CustomEditorModule,
  UndoRedoEditModule,
  CheckboxEditorModule,
  NumberEditorModule,
  ClientSideRowModelApiModule,
  ModuleRegistry,
  provideGlobalGridOptions,
  CsvExportModule,
  RowApiModule,
} from 'ag-grid-community';
import { Arrayify } from "../Functions/utils.jsx";
import { myOwnFPColor } from "../App/GridRenderers.jsx";

// Register all community features
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ColumnAutoSizeModule,
  RenderApiModule,
  ValidationModule,
  CellStyleModule,
  RowSelectionModule,
  TooltipModule,
  PinnedRowModule,
  TextFilterModule,
  TextEditorModule,
  CustomEditorModule,
  RowAutoHeightModule,
  UndoRedoEditModule,
  CheckboxEditorModule,
  NumberEditorModule,
  ClientSideRowModelApiModule,
  CsvExportModule,
  RowApiModule,

]);


// Mark all grids as using legacy themes
provideGlobalGridOptions({ theme: "legacy" });


export const AccordionSet = ({ children }) => {
  return (
    <Paper fullWidth={true} sx={{ width: "100%" }}>
      <Box sx={{ width: "100%" }}>
        <Stack spacing={0} sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>

          {children}
        </Stack>
      </Box>
    </Paper>

  )

}

export const AccountGrid = ({
  name,
  type,
  columnDef,
  data,
  add,
  cellClickedListener,
  addClick,
  accountType,
  quickStartOnClick = null,
  onGridReady = null,
}) => {
  const gridRef = useRef();
  const defaultColDef = useMemo(() => ({
    // flex: 1,
    field: "",
    sortable: false,
    resizable: true,
    suppressMovable: true,
    width: 100,
  }));
  const none = useMemo(() => "No " + name + " " + type, []);


  // const onRowDataUpdated = useCallback((event) => {
  //   event.api.autoSizeAllColumns();
  // }, []);

  const myGridReady = (params) => {
    if (onGridReady !== null) {
      onGridReady(params.api)
    }
  }

  const HeaderRows = (cd) => {
    let r = 0
    if (Arrayify(cd).length > 0) {
      r += 1
    }
    for (let c of Arrayify(cd)) {
      if (c.children !== null) {
        r += HeaderRows(c.children)
      }
    }
    return r
  }




  return (

    <Stack direction="row" spacing={2}>
      <Stack spacing={2} >
        {(add && addClick !== undefined) && (
          <CollapseAdd
            onClick={(e) => addClick(accountType, e)}
            tooltip={"Add " + accountType + " " + type.replace(/s$/, "")}
          />
        )}
        {(add && quickStartOnClick !== null) && (
          <QuickStartIcon
            onClick={quickStartOnClick}
          />
        )}
      </Stack>
      <div
        className="ag-theme-alpine"
        style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: 80 + (HeaderRows(columnDef) * 40) + Arrayify(data).length * 40 }}
      >
        <AgGridReact
          ref={gridRef} // Ref for accessing Grid's API
          rowData={data} // Row Data for Rows
          rowHeight={38}
          columnDefs={columnDef} // Column Defs for Columns
          defaultColDef={defaultColDef} // Default Column Properties
          tooltipShowDelay={1200}
          animateRows={true} // Optional - set to 'true' to have rows animate when sorted
          //suppressCellSelection={true}
          //rowSelection= {mode="singleRow"}
          onCellClicked={(e) =>
            cellClickedListener(accountType, e, gridRef)
          } // Optional - registering for Grid Event
          //overlayNoRowsTemplate={none}
          //
          overlayNoRowsTemplate={"<span>No " + name + " " + type + "</span>"}
          onGridReady={myGridReady}
        />
      </div>
    </Stack>
  )
}

export const AccordianGrid = ({
  eventKey,
  name,
  type,
  columnDef,
  data,
  add,
  cellClickedListener,
  addClick,
  accountType,
  quickStartOnClick = null,
  height = 400,
  useScenCrumb = false,
  clientJson = null,
  c_callback = null,
  onGridReady = null,
  openKey = "0",
  onClick_kb,
}) => {
  const title = () => {
    if (useScenCrumb) {
      return (
        <Stack direction="row">
          <CrumbToggleScenario
            set={[]}
            current=""
            onChange={() => { }}
            crumbClose={c_callback}
            clientJson={clientJson}
          />
          <Typography sx={{ mt: 2 }} id="who" variant="body" gutterBottom>
            {type}
          </Typography>
        </Stack>
      )
    } else {
      let t = name + " " + type + " (";
      if (data && data.length > 0) {
        let editable = data.filter(r => r.Editable === true).length
        if (editable > 0) {
          return t + editable + "," + data.length + ")"
        } else {
          return t + data.length + ")"


        }
        //return t + data.length + ")";
      }
      return t + "0)";
    }
  };


  const isSelected = () => {
    return openKey === eventKey
  }
  const bgColor = () => {
    return isSelected() ? myOwnFPColor : "default"
  }



  return (
    <Accordion
      sx={{ width: "100%" }}
      expanded={isSelected()}
      disableGutters
      onChange={(e, open) => { onClick_kb(eventKey, open) }}
    >
      <AccordionSummary sx={{ width: "100%", bgcolor: bgColor() }}
        expandIcon={<ExpandMoreIcon />}
      >
        {title()}
      </AccordionSummary>
      <center>
        <AccordionDetails>
          <AccountGrid
            name={name}
            type={type}
            columnDef={columnDef}
            data={data}
            add={add}
            addClick={addClick}
            cellClickedListener={cellClickedListener}
            accountType={accountType}
            onClick_kb={onClick_kb}
            openKey={openKey}
            quickStartOnClick={quickStartOnClick}
            onGridReady={onGridReady}
          />
        </AccordionDetails>
      </center>
    </Accordion >
  );
};


// export const ScenarioAccountGrid = ({
//   name,
//   type,
//   columnDef,
//   data,
//   add,
//   addClick,
//   cellClickedListener,
//   onClick_kb,
//   openKey,

//   show,
//   clientJson, 
//   c_callback,
//   clients,
//   client,
//   accountType,
//   btnClientChanged,
//   onSubmit,



// }) => {
//   return (
//     <>
//      <AddDialog
//             clientJson={clientJson}
//             c_callback={c_callback}
//             onClose={myClose}
//             open={show}
//             clients={clients}
//             client={client}
//             label={accountType + " Saving Rule"}
//             accountType={accountType}
//             onClientChange={btnClientChanged}
//             onSubmit={onSubmit}
//             errors={errors}
//             errmsg={errmsg}
//             deleted={deleted}
//             extraButton={spouseButtonCheck() ? "Submit <<" + client + "'s>> rules and Copy rules to <<" + spouse + ">>" : null}
//             extraButtonTooltip={"Submit this rule, and then while doing copy all rules to spouse, replacing all " + spouse + "'s rules"}
//             onExtraButton={copyAllRulesToSpouse}
    
//           >
//              <AccountGrid
//             name={name}
//             type={type}
//             columnDef={columnDef}
//             data={data}
//             add={add}
//             addClick={addClick}
//             cellClickedListener={cellClickedListener}
//             accountType={accountType}
//             onClick_kb={onClick_kb}
//             openKey={openKey}
//             quickStartOnClick={quickStartOnClick}
//             onGridReady={onGridReady}
//           />
//           </AddDialog>
//     </>
//   )
// } 

